// CategoryCard.jsx
import React from "react";
import { cn } from "@/lib/utils";

export const CategoryCard = ({
  size,
  icon,
  title,
  isActive,
  onClick,
  name,
}) => {
  return (
    <div className={size}>
      {" "}
      {/* Ajustado al 20% */}
      <div
        onClick={onClick}
        className={cn(
          "h-24 w-full flex flex-col items-center justify-center rounded-lg shadow-md",
          "cursor-pointer transition-all duration-200 hover:scale-105",
          isActive
            ? "bg-orange-500 text-white shadow-orange-200"
            : "bg-white text-orange-500 hover:bg-orange-50"
        )}
      >
        <div
          className={cn(
            "text-3xl mb-1",
            isActive ? "text-white" : "text-orange-500"
          )}
        >
          {icon}
        </div>
        <span
          className={cn(
            "font-medium text-xs text-center px-1",
            "whitespace-normal break-words"
          )}
        >
          {name}
        </span>
      </div>
    </div>
  );
};
